import { useEffect } from 'react';
import { ReportStatus, ReportVersion } from 'types/ModelTypes';
import { AxiosRequestConfig } from 'axios';
import useApi from './useApi';
import { ApiEndpoints, ApiQueryParams } from './apiEndpointUtils';
import { useToast } from 'hooks/useToast';
import { getReportVersionDownloadErrorMessage, getReportVersionHistoryError } from 'pages/emission/reportVersionUtils';

export default () => {
    const { state, getApiData } = useApi();
    const { toastError } = useToast();

    const downloadReportVersion = (companyId: number, reportStatusId: number, reportVersion: ReportVersion) => {
        const headers = { 'Content-Type': 'blob' };
        const config = {
            responseType: 'arraybuffer',
            headers,
        };

        getApiData({
            endpoint: ApiEndpoints.downloadExcelReportVersion,
            queryParam: ApiQueryParams.downloadExcelReportVersion(companyId, reportStatusId, reportVersion.reportVersionId),
            config: config as AxiosRequestConfig,
            additionalInfo: reportVersion,
        });
    };

    const downloadReport = (companyId: number, reportStatus: ReportStatus) => {
        getApiData({
            endpoint: ApiEndpoints.getLatestReport,
            queryParam: ApiQueryParams.getLatestReport(companyId, reportStatus.reportStatusId),
            additionalInfo: { companyId, reportStatusId: reportStatus.reportStatusId },
        });
    };

    useEffect(() => {
        if (state.status === 'success' && state.endpoint === ApiEndpoints.getLatestReport) {
            downloadReportVersion(
                state.additionalInfo.companyId,
                state.additionalInfo.reportStatusId,
                state.result as ReportVersion
            );
            return;
        }

        if (state.status === 'success') {
            const data = state.result as any;
            const url = URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', state.additionalInfo.fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }

        if (state.status === 'error' && (state.endpoint === ApiEndpoints.getLatestReport || state.endpoint === ApiEndpoints.downloadExcelReportVersion)) {
            toastError(getReportVersionDownloadErrorMessage(getReportVersionHistoryError(state.error)));
        }
    }, [state]);

    return { downloadReport, downloadReportVersion };
};
